import React, {
    useEffect,
    useRef,
    useState,
} from 'react'
import {Text} from '@react-three/drei'
import {
    TIME_RANGES,
    QUARTER_DAY,
} from '../utils/constants.jsx'

export function DayNightDebug({position = [0, 0, 0], visible = true}) {
    const [timeInfo, setTimeInfo] = useState({
        currentTime: '',
        mixValue: 0,
        timeOfDay: ''
    })

    // Store the last calculation time and result
    const lastCalculation = useRef({
        time: 0,
        mixValue: 0,
        timeOfDay: ''
    })

    // Function to calculate the mix value based on the time
    const calculateMixValue = (timeInMinutes) => {

        let mixValue = 0
        let timeOfDay = ''

        // Full day (10H - 16H): mix = 0
        if (timeInMinutes >= TIME_RANGES.day.start && timeInMinutes < TIME_RANGES.day.end) {
            mixValue = 0
            timeOfDay = 'Day'
        }
        // Evening transition (16H - 22H): mix from 0 to 1
        else if (timeInMinutes >= TIME_RANGES.evening.start && timeInMinutes < TIME_RANGES.evening.end) {
            mixValue = (timeInMinutes - TIME_RANGES.evening.start) / QUARTER_DAY
            timeOfDay = 'Evening'
        }
        // Full night (22H - 04H): mix = 1
        else if (timeInMinutes >= TIME_RANGES.night.start || timeInMinutes < TIME_RANGES.morning.start) {
            mixValue = 1
            timeOfDay = 'Night'
        }
        // Morning transition (04H - 10H): mix from 1 to 0
        else if (timeInMinutes >= TIME_RANGES.morning.start && timeInMinutes < TIME_RANGES.morning.end) {
            mixValue = 1 - ((timeInMinutes - TIME_RANGES.morning.start) / QUARTER_DAY)
            timeOfDay = 'Morning'
        }

        return {mixValue, timeOfDay}
    }

    useEffect(() => {
        // Do initial calculation
        const now = new Date()
        const hours = now.getHours()
        const minutes = now.getMinutes()
        const currentTimeInMinutes = hours * 60 + minutes

        const {mixValue, timeOfDay} = calculateMixValue(currentTimeInMinutes)

        // Store initial calculation
        lastCalculation.current = {
            time: now.getTime(),
            mixValue,
            timeOfDay
        }
        // console.log('test')

        // Display timer updates more frequently (5 seconds)
        const displayTimer = setInterval(() => {
            const currentTime = new Date()

            // Format the time string for display
            const timeString = currentTime.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }) + ' GMT+2'

            // USE FOR DIGITAL CLOCK
            // const timeString = currentTime.toLocaleTimeString([], {
            //     hour: '2-digit',
            //     minute: '2-digit',
            //     hour12: false
            // })

            // Check if we need to recalculate the mix value (every 15 minutes)
            const minutesSinceLastCalc = (currentTime.getTime() - lastCalculation.current.time) / (1000 * 60)

            if (minutesSinceLastCalc >= 15) {
                // Time to recalculate
                const hours = currentTime.getHours()
                const minutes = currentTime.getMinutes()
                const currentTimeInMinutes = hours * 60 + minutes

                const {mixValue, timeOfDay} = calculateMixValue(currentTimeInMinutes)

                // Update our stored calculation
                lastCalculation.current = {
                    time: currentTime.getTime(),
                    mixValue,
                    timeOfDay
                }
            }

            // Update the display with current time and latest calculated mix value
            setTimeInfo({
                currentTime: timeString,
                mixValue: lastCalculation.current.mixValue.toFixed(2),
                timeOfDay: lastCalculation.current.timeOfDay
            })
            // console.log(currentTime)
        }, 1000) // Update display every 10 seconds

        return () => clearInterval(displayTimer)
    }, [])

    return (
        <group position={position} name='time_debug_mesh'>
            <Text
                name='time_debug_text'
                position={[0, 0, 7.4]}
                rotation-y={Math.PI}
                // font='./fonts/digital_7_regular.ttf' // Digital-7 Regular Free for personal use
                fontSize={0.5}
                color='white'
                anchorX='center'
                anchorY='middle'
                outlineWidth={0.02}
                outlineColor='black'
                visible={visible}
            >
                {`${timeInfo.currentTime}\nTime of Day: ${timeInfo.timeOfDay}\nMix Value: ${timeInfo.mixValue}`}

                {/* USE FOR DIGITAL CLOCK */}
                {/*{`${timeInfo.currentTime}`}*/}
            </Text>
        </group>
    )
}